import CheckCircleIcon from '../../../Icon/CheckCircleIcon.js';
import EditorHintIcon from '../../../Icon/EditorHintIcon.js';
import EditorNoteIcon from '../../../Icon/EditorNoteIcon.js';
import ErrorIcon from '../../../Icon/ErrorIcon.js';
import InfoIcon from '../../../Icon/InfoIcon.js';
import QuestionCircleIcon from '../../../Icon/QuestionCircleIcon.js';
import WarningIcon from '../../../Icon/WarningIcon.js';

//
var script = {
  name: 'Panel',
  components: {
    InfoIcon,
    WarningIcon,
    ErrorIcon,
    TipIcon: EditorHintIcon,
    NoteIcon: EditorNoteIcon,
    SuccessIcon: CheckCircleIcon,
    QuestionCircleIcon
  },
  props: ['node', 'updateAttrs', 'view'],
  computed: {
    appearance() {
      return this.node && this.node.attrs.panelType;
    }

  }
};

export default script;



// WEBPACK FOOTER //
// ./node_modules/@spartez/vue-atlaskit/dist/components/RichTextEditor/custom-extensions/renderers/Panel.vue_rollup-plugin-vue=script.js